import React from 'react';
import { FlameIcon } from 'lucide-react';
const SPOTS_LEFT = 17;
const PERCENT_TAKEN = 93;
export function ScarcityBar() {
  return <div className="w-full rounded-2xl border border-orange-500/25 bg-orange-500/[0.07] p-4" data-id="element-201" data-mp="2yvt5mhjtb9um">
      <div className="mb-2 flex items-center justify-between gap-3" data-id="element-202" data-mp="2l44qs6i6i79y">
        <span className="flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-wide text-orange-300 sm:text-xs" data-id="element-203" data-mp="2q37of5vtxb7w">
          <FlameIcon className="h-4 w-4" data-id="element-204" data-mp="2b5yqftc0t977" /> Promotional price
        </span>
        <span className="text-[11px] font-bold uppercase tracking-wide text-white/70 sm:text-xs" data-id="element-205" data-mp="2g63aftc50m26">
          Only {SPOTS_LEFT} spots left
        </span>
      </div>
      <div className="h-3 w-full overflow-hidden rounded-full bg-white/10" role="progressbar" aria-valuenow={PERCENT_TAKEN} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-206" data-mp="228enmfyif4uh">
        <div className="h-full rounded-full bg-gradient-to-r from-orange-500 to-lime" style={{
        width: `${PERCENT_TAKEN}%`
      }} data-id="element-207" data-mp="5ch1mx9epj1p" />
      </div>
      <p className="mt-2 text-center text-[11px] font-medium text-white/55 sm:text-xs" data-id="element-208" data-mp="2zlt8444ob14a">
        {PERCENT_TAKEN}% of today’s promotional spots have already been claimed.
      </p>
    </div>;
}